import {sanitizeAndDecode} from './utils'

/**
 * File for Google Analytics Functions & Configuration
 */
const searchTypeOptions = new Set(['manual', 'suggested'])

const resultCategory = {
  data: 'datasets',
  main: 'most relevant',
}
/** Capture search journey data in Google Analytics  before Users clicks off results page. */
export const captureGA = (e, state) => {
  const url = new URL(window.location.href)

  const search_term = sanitizeAndDecode(state.query).toLowerCase()
  const search_type = sanitizeAndDecode(
    url.searchParams.get('search_type'),
  ).toLowerCase()
  const search_result_page_number = state.currentPagination
  const search_result_category = resultCategory[state.filter] || 'most relevant' // when a user clicks a search result, pass in 'most relevant' or 'datasets' to indicate which result page category they were on.
  const search_result_position =
    Number(e.target.getAttribute('data-resultPosition')) + 1 //0 based, so adding 1
  const search_result_page_title = e.target.textContent
  const search_result_page_url = e.target.href
  window.dataLayer ||= []
  window.dataLayer.push({
    event: 'click_search_results',
    search_term, // pass in the query that was searched for to get the user to the search result page. In all lowercase.
    search_type: searchTypeOptions.has(search_type) ? search_type : 'unknown', // pass in the search type that was used to get the user to the search result page. Eg ‘manual search’ or ‘suggested search’.
    search_result_page_number, // when a user clicks a search result, pass in the search result page they were on
    search_result_position, // when a user clicks a search result, pass in the position the result was on the page
    search_result_category,
    search_result_page_title,
    search_result_page_url,
  })
}
